import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
// import {ToastrService} from 'ngx-toastr';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'jalali-moment';
import {ICustomer} from '../../shared/model/customer.model';
import {ITransaction} from '../../shared/model/transaction.model';
import {CustomerService} from '../../entities/customer/customer.service';
import {AccountService} from '../../singelton/account.service';
import {TransactionService} from '../../entities/transaction/transaction.service';
import {NoteService} from '../../entities/note/note.service';
import {TransactionUpdateComponent} from '../../entities/transaction/transaction-update.component';
import {CustomerAssignUserDialogComponent} from '../../entities/customer/customer-assign-user-dialog.component';
import {COMPANY_NAME} from "../../app.constants";
import {FactorService} from '../../entities/factor/factor.service';
import {IFactorWorkflowListItem} from '../../shared/model/factor-workflow.model';
import {canAccessFactorWorkflowKartabl} from '../../shared/util/factor-workflow-access.util';


@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss']
})
export class NotificationDialogComponent implements OnInit {
  @Input() counter_stock_alarm_point;
  @Input() counter_stock_order_point;
  isSaving: boolean;
  company_name= COMPANY_NAME;

  width: any = '';
  counter_task: Number = 0;
  counter_note: Number = 0;
  counter_flow: Number = 0;
  customers: ICustomer[];
  transactions: ITransaction[];
  factorWorkflowTodayItems: IFactorWorkflowListItem[] = [];
  factorWorkflowTodayCount = 0;
  error: any;
  success: any;
  userParam: any;
  // eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;

  constructor(protected activatedRoute: ActivatedRoute,
              public activeModal: NgbActiveModal,
              // private toastr: ToastrService,
              protected customerService: CustomerService,
              protected accountService: AccountService,
              protected transactionService: TransactionService,
              // protected orderDashboardService: OrderDashboardService,
              protected noteService: NoteService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              protected factorService: FactorService,
              public router: Router,) {

    this.itemsPerPage = 15;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';
  }

  showProfileSupplier(val) {
    this.router.navigate(['/page/supplier/' + val + '/order']);
    this.clear();

  }
  showProfile(val) {
    this.router.navigate(['/page/profile-customer-project/' + val + '/other']);
    this.clear();

  }

  showProfilePrj(val) {
    // this.router.navigate(['/page/profile-customer-project/' + val + '/project']);
    this.router.navigate(['/page/profile-project/' + val ]);
    this.clear();

  }

  showProfileSales(val) {
    // this.accountService.identity().then(identi => {
      // if (identi.authorities.find(role => role === 'ROLE_ADMIN')) {
        this.router.navigate(['/page/profile-customer-project/' + val + '/salesCycle']);
      // } else if (identi.authorities.find(role => role === 'KARBORD_MENU')) {
      //   this.router.navigate(['/page/profile-customer-project/' + val + '/salesCycle']);
      //
      // } else {
      //   this.router.navigate(['/page/profile-customer-project-user/' + val + '/salesCycle']);
      // }
    // });

    this.clear();

  }

  ngOnInit() {
    this.isSaving = false;
    this.loadMyOrder();
    this.getTaskNotification();
    this.loadMyTaskCount();
    this.loadMyNote();
    this.getCustomerNotification();
    this.loadFactorWorkflowToday();
  }


  protected onError(errorMessage: string) {
  }

  previousState() {
    // window.history.back();
  }

  parseDate(value) {
    // alert(' val ' + value);
    let jalaliDate5 = '-';
    if (value) {
      // jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD HH:mm:ss'); // 1367/11/4
      jalaliDate5 = moment(value).locale('fa').format('jYYYY/jM/jD');
    } // 1367/11/4


    // alert(' jalaliDate5 ' + jalaliDate5);

    return jalaliDate5;
  }


  update() {
  }

  // protected subscribeToSaveResponseUpdate(result: Observable<HttpResponse<ICustomer>>) {
  // }


  protected onSaveSuccessUpdate(res) {
    this.isSaving = false;
    // this.toastr.success('     ثبت تغييرات با موفقیت انجام شد.     ', '   کاربر گرامی!    ');
    this.clear();

  }


  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


  loadMyTaskCount() {
    this.accountService.identity().then(account => {
      const employeeId = account.id;
      this.transactionService.findMyTransactionCount(employeeId).subscribe(
        (res: HttpResponse<any>) => {
          // this.transactions = res.body;
          this.counter_task = res.body;
          // alert('counter_task == ' + this.counter_task);
          // this.spinner.hide();

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    });

  }


  loadMyOrder() {

    const employeeId = 1;

    // this.accountService.identity().then(account => {
    //   employeeId = account.id;
    //   this.orderDashboardService
    //     .findMyOrderCount(employeeId)
    //     .subscribe(
    //       (res: HttpResponse<any>) => {
    //         this.counter_flow = res.body;
    //         // alert('counter_flow == ' + this.counter_flow);
    //
    //       },
    //       (res: HttpErrorResponse) => this.onError(res.message)
    //     );
    // });

  }

  loadMyNote() {

    let employeeId = 1;

    this.accountService.identity().then(account => {
      employeeId = account.id;
      this.noteService
        .findMyNoteCount(employeeId)
        .subscribe(
          (res: HttpResponse<any>) => {
            this.counter_note = res.body;
            // alert('counter_note == ' + this.counter_note);

          },
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    });

  }


  getCustomerNotification() {
    this.spinner.show();
    this.customerService
      .getCustomerNotification({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  getTaskNotification() {
    this.spinner.show();
    this.transactionService
      .getTransactionNotification({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
      })
      .subscribe(
        (res: HttpResponse<ITransaction[]>) => this.paginateTransaction(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  sort() {
    let result = ['id, desc'];
    if (this.predicate) {
      result = [this.predicate + ',' + this.reverse];
      return result;
    }
  }


  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();


    // alert(' in succsess === ' + this.customer);
  }

  protected paginateTransaction(data: ITransaction[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.transactions = data;
    this.spinner.hide();


    // alert(' in succsess === ' + this.customer);
  }


  percentCellRenderer(value, status, status_2) {
    const today = new Date();
    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;
    const valueNumber = Number(value + '');
    let valueStr = '';
    const eDivPercentBar = document.createElement('div');
    eDivPercentBar.className = '';
    const eValue = document.createElement('div');
    valueStr = 'Expired';

    eValue.className = 'progress-bar progress-bar-striped bg-primary';

    if (status_2 && status_2 === 'completed') {
      valueStr = 'بررسی شد.';
      eValue.style.width = '100%';
      eValue.style.paddingLeft = '1px';
      eValue.style.color = 'green';

    } else {
      if (valueNumber < 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز گذشته';
      } else if (valueNumber === 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز مانده';
      } else if (valueNumber < 30 && valueNumber > 0) {
        eValue.style.width = '80%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-warning';
      } else if (valueNumber < 60 && valueNumber > 0) {
        eValue.style.width = '60%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-info';
      } else if (valueNumber < 90 && valueNumber > 0) {
        valueStr = value + ' روز';
        eValue.style.width = '40%';
        eValue.className = 'progress-bar progress-bar-striped bg-succsess';
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          // alert(status);
          valueStr = 'بدون مهلت';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        } else {
          valueStr = 'Not Uploaded';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        }
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      } else {
        eValue.style.width = '45%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      }
    }
    const eOuterDiv = document.createElement('div');
    eOuterDiv.className = 'progress mb-2';
    eOuterDiv.style.marginTop = '12px';
    eOuterDiv.appendChild(eValue);
    const re = /&lt;/gi;
    const re2 = /&gt;/gi;
    const str = eOuterDiv.outerHTML;
    const newstr = str.replace(re, '<').replace(re2, '>');
    const newstr2 = str.replace(re, '>');
    return valueStr;
  }


  styleObject(value, status, status_2): Object {
    const today = new Date();

    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;
    const valueNumber = Number(value + '');

    if (status_2 && status_2 === 'completed') {
      this.width = '100%';
      return {width: this.width, 'background-color': '#168016'};

    } else {

      if (valueNumber <= 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#dc3545'};
      } else if (valueNumber < 30 && valueNumber > 0) {
        this.width = '80%';
        return {width: this.width, 'background-color': '#ffc107'};
      } else if (valueNumber < 60 && valueNumber > 0) {
        this.width = '60%';
        return {width: this.width, 'background-color': '#17a2b8'};
      } else if (valueNumber < 90 && valueNumber > 0) {
        this.width = '40%';
        return {width: this.width, 'background-color': '#007bff'};
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        } else {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        }
      } else {
        this.width = '45%';
        return {width: this.width, 'background-color': '#007bff'};
      }
    }
  }

  classObject() {
    const thisClass = 'progress-bar progress-bar-striped bg-primary';
    return {thisClass};
  }

  loadPage(page: number) {
    if (page !== this.previousPage) {
      this.previousPage = page;
      this.getTaskNotification();
    }
  }

  loadPage2(param) {
    if (this.predicate === param) {
      if (this.reverse === 'asc') {
        this.reverse = 'desc';
      } else {
        this.reverse = 'asc';
      }
    } else {
      this.reverse = 'asc';
    }
    this.predicate = param;
  }

  openLink() {
    this.clear();
    this.router.navigate(['/page/customer-page']);
  }

  goToStock() {
    this.clear();
    this.router.navigate(['/page/stocks']);
  }

  openLinkTransaction() {
    this.clear();
    this.router.navigate(['/page/mytransaction']);
  }

  openLinkFactorWorkflowKartabl() {
    this.clear();
    this.router.navigate(['/page/factor-workflow-kartabl'], {queryParams: {tab: 'today'}});
  }

  openFactorWorkflow(item: IFactorWorkflowListItem): void {
    if (!item || !item.projectId || !item.id) {
      return;
    }
    this.clear();
    this.router.navigate(['/page/profile-project', item.projectId, 'factor-process'], {
      queryParams: {factorId: item.id}
    });
  }

  formatFactorWorkflowDate(value: string): string {
    if (!value) {
      return '-';
    }
    try {
      return moment(new Date(value)).locale('fa').format('jYYYY/jMM/jDD HH:mm');
    } catch (e) {
      return value;
    }
  }

  loadFactorWorkflowToday(): void {
    if (!canAccessFactorWorkflowKartabl(this.accountService)) {
      return;
    }
    this.factorService.listMyWorkflowTasks({
      page: 0,
      size: 15,
      sort: ['id,desc'],
      dueTodayOnly: true
    }).subscribe(
      (res: HttpResponse<IFactorWorkflowListItem[]>) => {
        this.factorWorkflowTodayItems = res.body || [];
        this.factorWorkflowTodayCount = parseInt(res.headers.get('X-Total-Count') || '0', 10);
      },
      () => {
      }
    );
  }


  completedTransaction(data: any, type) {
    const modalRef = this.modalService.open(TransactionUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    modalRef.componentInstance.action = 'completed';
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.transactionEdit = data;

    modalRef.result.then(
      res => {
        // console.log(res + ' the result of popup');
        // this.loadTransaction();
        // alert(' in jjjjjjjjjjjjjjjjj')

        this.getTaskNotification();
      },
      rejected => {
        // alert(' in reddd')
        // console.log(' rejected: ' + rejected.toString());
        // this.loadTransaction();
        this.getTaskNotification();

      }
    );
  }


  assignUsersSingle(val) {
    const modalRef = this.modalService.open(CustomerAssignUserDialogComponent, {windowClass: 'md', backdrop: 'static'});
    modalRef.componentInstance.action = 'add';
    modalRef.componentInstance.type = val;
    modalRef.componentInstance.customerId = val;
    modalRef.result.then(
      res => {
        this.getCustomerNotification();
      },
      rejected => {
        this.getCustomerNotification();
      }
    );
  }


  loadMyTask() {
    // alert(' in lad All ');
    this.spinner.show();
    this.accountService.identity().then(account => {
      // alert(' in account ==' + account.id);
      const employeeId = account.id;

      this.transactionService.findMyTransaction(employeeId).subscribe(
        (res: HttpResponse<ITransaction[]>) => {
          this.transactions = res.body;
          this.spinner.hide();

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    });
  }


  completedTransactionForPrj(data: any, type, project, customer) {
    // alert(' in comp  this.projects==='+this.projects);
    // alert(' in comp  this.phones==='+this.phones);
    // alert(' in comp  this.employee_list==='+this.employees);
    const modalRef = this.modalService.open(TransactionUpdateComponent, {windowClass: 'sm', backdrop: 'static'});
    modalRef.componentInstance.action = 'completed';
    modalRef.componentInstance.type = type;
    modalRef.componentInstance.transactionEdit = data;
    modalRef.componentInstance.customer_project_param = project;

    // modalRef.componentInstance.action = 'completed';
    // modalRef.componentInstance.type = type;
    // modalRef.componentInstance.transactionEdit = data;
    // modalRef.componentInstance.customer_project_param = project;
    if (project) {
      modalRef.componentInstance.part = 'project';
    }
    // modalRef.componentInstance.projects_list = this.projects;
    // modalRef.componentInstance.employees_list = this.employees;
    // modalRef.componentInstance.phones_list = this.phones;
    // modalRef.componentInstance.contracts_list = this.contracts;
    // modalRef.componentInstance.customerId = this.customer.id;


    // modalRef.componentInstance.projects_list = this.projects;
    // modalRef.componentInstance.employees_list = this.employees;
    // modalRef.componentInstance.phones_list = this.phones;
    // modalRef.componentInstance.contracts_list = this.contracts;
    if(customer && customer.id) {
      modalRef.componentInstance.customerId = customer.id;

    }
    modalRef.result.then(
      res => {
        // console.log(res + ' the result of popup');
        // this.loadTransaction();
        // this.loadAllProject();
        this.getTaskNotification();

      },
      rejected => {
        // console.log(' rejected: ' + rejected.toString());
        // this.loadTransaction();
        // this.loadAllProject();
        this.getTaskNotification();


      }
    );
  }

}
